import { Box, Button, Dialog, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogBoxContent } from '../DialogBoxContent/DialogBoxContent';

interface BlockLeaveAddFlowModalProps {
    showBlockModal: boolean;
    onCloseBlockModal: () => void;
    onSubmitModal: () => void;
    title?: string;
    message?: string;
    submitButtonText?: string;
    cancelButtonText?: string;
}

export const BlockLeaveAddFlowModal = memo(
    ({
        showBlockModal,
        onCloseBlockModal,
        onSubmitModal,
        title,
        message,
        submitButtonText,
        cancelButtonText,
    }: BlockLeaveAddFlowModalProps) => {
        const { t } = useTranslation();

        if (!showBlockModal) {
            return null;
        }

        return (
            <Dialog open onClose={onCloseBlockModal}>
                <DialogBoxContent
                    onClose={onCloseBlockModal}
                    buttons={
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            width="100%"
                        >
                            <Button onClick={onCloseBlockModal}>
                                {cancelButtonText ?? t('Keep editing')}
                            </Button>
                            <Button
                                onClick={onSubmitModal}
                                variant="contained"
                                color="primary"
                            >
                                {submitButtonText ?? t('Cancel order')}
                            </Button>
                        </Box>
                    }
                >
                    <Box maxWidth="280px">
                        <Typography marginBottom="21px" variant="subtitle2">
                            {title ?? t('Cancel Order')}
                        </Typography>
                        <Typography marginBottom="12px" variant="body2">
                            {message ??
                                t(
                                    'Are you sure you want to cancel this order? All unsaved changes will be lost.',
                                )}
                        </Typography>
                    </Box>
                </DialogBoxContent>
            </Dialog>
        );
    },
);

BlockLeaveAddFlowModal.displayName = 'BlockLeaveAddFlowModal';
